<template>
    <div class="">
        <template>
            <ve-table ref="userVeTable" :max-height="700" :fixed-header="true" row-key-field-name="rowKey"
                :auto-height="true" :virtual-scroll-option="virtualScrollOption" :columns="getColumns"
                :sort-option="sortOption" :scroll-width="'70vw'" :cellSelectionOption="cellSelectionOption"
                :row-style-option="rowStyleOption" :event-custom-option="eventCustomOption" :table-data="users" />
        </template>
    </div>
</template>
<script>
import { sortChange } from "@/mixins/vueEasyTable/sortChange";
import { mapGetters } from "vuex";
import UploadImage from "./uploadImage.vue";

export default {
    name: "userTable",
    components: {},
    mixins: [sortChange],
    props: ['users'],
    data() {
        return {
            eventCustomOption: {
                bodyRowEvents: ({ row, rowIndex }) => {
                    return {
                        click: (event) => {
                            if (event.target.tagName.toLowerCase() === 'button' || event.target.closest('button')) {
                                return;
                            }
                        },
                    };
                },
            },
            virtualScrollOption: {
                enable: false,
            },
            rowStyleOption: {
                stripe: true,
                clickHighlight: true,
                hoverHighlight: true,
            },
            cellSelectionOption: {
                enable: false,
            },
        }
    },
    computed: {
        ...mapGetters('users', ['getClaims']),
        texts(){
            return {
                RemoveNFC: this.$t('admin.users.NFC.removeNFC'),
                RegisterNFC: this.$t('admin.users.NFC.registerNFC')
            }
        },
        getColumns() {
            return [
                {
                    field: "Image",
                    key: '1',
                    title: this.$t('admin.users.image'),
                    align: "left",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <div class="row" style="height:120px; display:flex; align-items:center; justify-content:center;">
                                <div class="col-12">
                                    <UploadImage profilePicture={row.photo} userUid={row.uid} />
                                </div>
                            </div>
                        )
                    }
                },
                {
                    field: "DisplayName",
                    key: '2',
                    title: this.$t('admin.users.displayName'),
                    align: "left",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return h('div', { class: "display-name-cell" }, [
                            h('div', { class: "display-name" }, row.displayName ? row.displayName : "-")
                        ])
                    }
                },
                {
                    field: "Email",
                    key: '3',
                    title: this.$t('admin.users.email'),
                    align: "left",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return h('div', { class: "email-cell" }, [
                            h('div', { class: "email" }, row.email ? row.email : "-")
                        ])
                    }
                },
                {
                    field: "Role",
                    key: '4',
                    title: this.$t('admin.users.role'),
                    align: "left",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        let claims = row.customClaims
                        if (!claims) {
                            return h('div', { class: "role-cell" }, '');
                        }

                        let label = '-';
                        if (claims.root) {
                            label = 'ROOT';
                        } else if (claims.admin) {
                            label = 'Admin';
                        } else if (claims.teamlead) {
                            label = 'Teamlead';
                        } else if (claims.manager) {
                            label = 'Manager';
                        }

                        return h('div', { class: "role-cell" }, [
                            h('div', { class: "role" }, label)
                        ]);
                    }
                },
                {
                    field: "actions",
                    key: '5',
                    title: this.$t('taskDefinition.table.actions'),
                    align: "left",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        let nfcId = row.nfcId
                        return (
                            <div class="row">
                                <div class="text-width-auto mr-3">
                                    <button
                                        class={nfcId ? "framework-text-button-danger" : "framework-text-button-primary"}
                                        onClick={() => this.handleUserClick(row)}
                                    >
                                        {nfcId ? this.texts.RemoveNFC : this.texts.RegisterNFC}
                                    </button>
                                </div>
                                <div class="text-width-auto mr-3">
                                    <router-link
                                        to={`/admin/user/${row.uid}`}
                                        class="framework-text-button-primary"
                                        tag="button"
                                    >
                                        {this.$t('ui.edit')}
                                    </router-link>
                                </div>
                                <div class="text-width-auto">
                                    <button
                                        tag="delete-product-button"
                                        class="framework-text-button-primary far fa-trash delete"
                                        onClick={() => this.deleteUser(row)}
                                    >
                                    </button>
                                </div>
                            </div>
                        )
                    }
                },
            ]
        },
        getUsers(){
            return this.users
        }
    },
    methods: {
        handleUserClick(userRow) {
            this.selectedUser = userRow
            if (userRow.nfcId) {
                this.removeNfcTag(userRow.uid)
            } else {
                this.$emit("show-modal", userRow)
            }
        },
        async removeNfcTag() {
            this.$swal.fire({
                title: this.$t('swal.delete.areyousure'),
                text: this.$t('swal.delete.remove') + ' NFC ' + this.$t('ui.from').toLowerCase() + ' ' + this.selectedUser.displayName + ' ' + this.$t('swal.delete.undone'),
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.value) {
                    this.$FB.collection('userData').doc(this.selectedUser.uid).update({
                        nfcId: null
                    })
                    this.selectedUser.nfcId = null
                    this.swalToastSuccess(this.$t("ui.save"));
                }
            })
        },
        deleteUser(user) {
            var self = this;
            this.$swal.fire({
                title: this.$t('swal.delete.areyousure'),
                text: this.$t('swal.delete.remove') + ' ' + user.displayName + ' ' + this.$t('swal.delete.undone'),
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.value) {
                    this.$store.commit('setLoading', true);
                    self.$FUNCTIONS.Users('deleteUser', { uid: user.uid, companyId: user.customClaims.companyId }).then(() => {
                        this.swalToastSuccess('Deleted');
                        this.users = this.users.filter(u => u.uid !== user.uid)
                        this.$emit('renderEvent')
                        this.$store.commit('setLoading', false);
                    }).catch(error => {
                        this.swalToastError(this.$t('swal.delete.error'));
                        this.$store.commit('setLoading', false);
                    })
                }
            });
        },
    }
}
</script>
<style lang="scss" scoped>
@import "@/assets/scss/components/desktop/ve-table-desktop.scss";
@import "@/assets/scss/components/desktop/frameworkButtonDesktop.scss";
@import "@/assets/scss/components/desktop/frameworkTextButtonDesktop.scss";
@import "@/assets/scss/components/desktop/frameworkModalDesktop.scss";
@import "@/assets/scss/_overwritesNewUi.scss";

.text-width-auto {
  width: auto;
  display: inline-block;
}
</style>